import React, { useEffect, useState } from 'react';
import { MainContainer } from '../components/Default/Layout/MainContainer';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Link,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import validator from 'validator';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { useApi } from '../hooks/useApi';
import { useNavigate } from 'react-router-dom';
import { url } from '../utils/url';
import { ForgotPassword } from '../api/UserApi';
import { useDispatch } from 'react-redux';
import { setAlert } from '../store/alert.store';

export const ForgotPasswordPage = () => {
  const { t } = useTranslation();

  const [form, setForm] = useState({
    email: '',
  });
  const [emailHelperText, setEmailHelperText] = useState(
    t('LoginEmailFieldHelperTextDefault'),
  );
  const [emailError, setEmailError] = useState(false);
  const ForgotPasswordApi = useApi(ForgotPassword);
  const navigate = useNavigate();
  useEffect(() => {
    if (form.email && !validator.isEmail(form.email)) {
      setEmailError(true);
      setEmailHelperText(t('LoginEmailFieldHelperTextError'));
    } else {
      setEmailError(false);
      setEmailHelperText(t('LoginEmailFieldHelperTextDefault'));
    }
  }, [form]);

  const dispatch = useDispatch();

  const ForgotPasswordHandler = async () => {
    try {
      const result = await ForgotPasswordApi.sendRequest({
        email: form.email,
      });

      if (result?.id) {
        dispatch(setAlert({ text: t('SuccessForgotPassword'), status: 200 }));
      }
    } catch (error) {}
  };
  return (
    <MainContainer needAuth={false}>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        sx={{ minHeight: '80vh' }}
      >
        <Grid item xs={12} sm={6} lg={4}>
          <Card variant="outlined" sx={{ borderRadius: '10px' }}>
            <CardContent>
              <Typography as="h1" variant="h6" sx={{ mb: 2 }}>
                {t('ForgotPasswordPageTitle')}
              </Typography>
              <TextField
                label={t('EmailFieldLabel')}
                helperText={emailHelperText}
                error={emailError}
                fullWidth
                sx={{ mb: 2 }}
                disabled={ForgotPasswordApi.loading}
                value={form.email}
                type="email"
                onChange={({ target: { value } }) =>
                  setForm({ ...form, email: value })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <LoadingButton
                variant="contained"
                color="primary"
                disabled={emailError}
                onClick={() => ForgotPasswordHandler()}
                loading={ForgotPasswordApi.loading}
              >
                {t('Continue')}
              </LoadingButton>
            </CardContent>
          </Card>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="center"
            sx={{ mt: 2 }}
          >
            <Box>
              <Link
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.5, cursor: 'pointer' }}
                onClick={() => navigate(url.registration)}
              >
                {t('registrationLink')}
              </Link>
            </Box>
            <Box>
              <Link
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.5, cursor: 'pointer' }}
                onClick={() => navigate(url.login)}
              >
                {t('loginLink')}
              </Link>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </MainContainer>
  );
};
